import API from "./API";

class Preregistration {
  static async create(data) {
    return await API.post("/public/pre-registration", data, { needAuth: true });
  }

  static async createUnauthenticated(data) {
    return await API.post("/public/pre-registration/unauthenticated", data);
  }

  static async get(id, locationId) {
    return await API.get(
      `/public/pre-registration/${id}?locationId=${locationId}`
    );
  }
}

export default Preregistration;
